export default __webpack_public_path__ + "static/scientist4-8f070227fc03de3c3b9fd6f1eaa57f3f.png";